import * as React from "react";
import * as ReactDOM from "react-dom";

import { AdminContainer } from "./components/admin/adminContainer";

ReactDOM.render(
    <AdminContainer />,
    document.getElementById("admin")
);
